const sidebar = {
    student: {
        name: "Student",
        create: "Create",
        list: "List",
        contact: "Contact\'s List",
        transcript: 'Transcripts',
        enrollmentReport: 'Enrollment Report'
    },

    alumni: {
        name: "Alumni",
        transcript: 'Transcripts',
        list: "List"
    },

    employee: {
        name: "HR Management",
        professor: {
            create: "Professor Create",
            list: "Professor List",
        },
        staff: {
            create: "Staff Create",
            list: "Staff List",
        },
        absence: 'Absence List',
        absenceAdd: 'Absence Request',
        reason: 'Absence Types',
        holiday: 'Local Holidays'
    },

    program: {
        name: "Program",
        create: "Create",
        list: "List"
    },

    company: {
        name: "Company",
        create: "Create",
        list: "List"
    },

    course: {
        name: "Course",
        create: "Create",
        list: "List"
    },

    book: {
        name: "Book",
        create: "Create",
        list: "List",
        submission: "Add Submission",
        edit_submission: "View/Edit Submissions",
    },

    bookBundle: {
        name: "Book Bundle",
        create: "Create",
        list: "List"
    },

    invoice: {
        heading: "Invoices",
        name: "All invoices",
        batch: 'Batch Invoicing',

        student: {
            name: "Student Invoices",
            create: "Create",
            list: "List",
            listPaid: "Paid List",
            listUnpaid: "Unpaid List",
            listPending:"Pending List",
            emailed: 'E-mailed Invoices'
        },

        company: {
            name: "Company Invoices",
            create: "Create",
            list: "List",
            listPaid: "Paid List",
            listUnpaid: "Unpaid List"
        }
    },

    paymentSummaries: {
        heading: "Payment Summaries",
        list: "List",
        listPending:"Pending List",
    },

    import: {
        heading: "Imports",
        name: "Data Import",
        list: "Preliminary List",
        record: "Import Record",
        student: "Students",
        applicationDocuments: "Application Documents",
        grade: "Grades",
        graduation: "Graduation",
        status: "Status",
    },

    notification: {
        heading: "Notifications",
        name: "Notifications",
        create: "Create Batch",
        list: "List",
        editor: "Notification Templates",
    },

    setting: {
        list: 'List',
        heading: "Settings",
        name: "Settings",
        finance: {
            finance: 'Finance',
            tuitionFee:'Tuition Fee',
            reductionTypes:'Reduction Types',
            fee:'Fee',
            create:'Create',
            list:'List'
        },
        hr: {
            hr: 'HR',
            departments: 'Departments',
            positions: 'Positions',
            hrStatus: 'Statuses'
        },
        partner: {
            name: "Partners",
            create: "Create",
            list: "List"
        },
        campus: {
            name: "Campus",
            create: "Create Campus",
            list: "Campus List"
        },
        registrar: {
            registrar: 'Registrar',
            gradingScaleTypes: 'Grading Scale Types',
            gradingScale: 'Grading Scale',
            create: 'Create',
            list: 'List',
            programCodesTypes: 'Program Codes & Types',
            transcriptTitle: 'Program Transcript Title',
            specializationMajor: 'Specialization & Major',
            statusManagement: 'Status Management',
        },
        security: {
            security: 'Security',
            auditLog: 'Audit Log',
            apiTokens: 'API Tokens',
            lockRecords: 'Locked Records',
            loginList: 'Login List',
            manageIP: 'Manage IPs',
            manage2fa: 'Manage 2FA',
        },
        users: {
            users: 'Users',
            create: 'Create',
            list: 'List',
            roles: 'Roles',
            password: 'Password',
            updatePassword: 'Update Password',
        },


        statuses: 'Statuses',      

    }
};

export default sidebar;